import { rem } from 'polished';
import styled, { css } from 'styled-components';

import { black, grayscale } from '@vimeo/iris/color';

import Search from '../components/Search';

export const PaddedWrapper = styled.div`
  padding-bottom: ${rem('72px')};
`;

const PaddedLayout = styled.div`
  padding-left: 65px;
  padding-right: 65px;

  @media only screen and (max-width: 1024px) {
    padding-left: 35px;
    padding-right: 35px;
  }
`;

interface Themed {
  thumbnail?: string;
  theme?: 'standard' | 'dark';
  isSearching?: boolean;
}

export const TopSwatch = styled(PaddedLayout)<Themed>`
  background-color: ${({ theme, isSearching }) =>
    theme === 'dark' || isSearching ? black : grayscale(50)};
  padding-bottom: ${rem('150px')};
  ${({ thumbnail, isSearching }) =>
    !isSearching &&
    thumbnail &&
    css`
      background-size: cover;
      background-image: linear-gradient(
          rgba(0, 0, 0, 0.25) 0%,
          rgba(0, 0, 0, 0.25) 50%,
          rgba(0, 0, 0, 0.25) 100%
        ),
        url(${thumbnail});
    `};
`;

export const BottomSwatch = styled(PaddedLayout)`
  position: relative;
  top: ${rem('-150px')};
`;

export const VideoGrid = styled.div`
  margin-bottom: ${rem('15px')};
  display: flex;
  display: grid;
  min-width: 330px;
  flex-wrap: wrap;
  grid-template-columns: repeat(auto-fill, minmax(${rem('330px')}, 1fr));

  @media screen and (min-width: ${rem(480)}) {
    min-width: 370px;
    grid-template-columns: repeat(auto-fill, minmax(${rem('370px')}, 1fr));
    grid-gap: ${rem('20px')};
  }
`;

export const GridHeaderWrapper = styled.div<{ isSearching: boolean | undefined }>`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: ${({ isSearching }) => (isSearching ? 'flex-end' : 'space-between')};
`;

export const FullScreen = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
`;

export const StyledSearch = styled(Search)`
  float: right;
  display: inline-block;
  vertical-align: middle;
`;
